import React from 'react';

import MenuItem from './menu/MenuItem.jsx';
import SubMenu from './menu/SubMenu.jsx';
import Menu from './menu/Menu.jsx';

class AttrA11yListDropDown extends React.Component {
    constructor(props) {
        super(props);
        // Generate unique IDs for ARIA relationships
        const attrId = props.attr.id;
        this.buttonId = `attr-menu-button-${attrId}`;
        this.menuId = `attr-menu-${attrId}`;
        // Generate unique IDs for menu items
        this.subMenuId = `attr-submenu-${attrId}`;
        this.menuItemIds = {
            edit: `attr-menu-item-edit-${attrId}`,
            addToX: `attr-menu-item-x-${attrId}`,
            addToY: `attr-menu-item-y-${attrId}`,
            addToY2: `attr-menu-item-y2-${attrId}`,
            colorBy: `attr-menu-item-colorby-${attrId}`,
            orderBy: `attr-menu-item-orderby-${attrId}`
        };
    }

    _onItemClick = (e, menu) => {
        e.preventDefault();
        e.stopPropagation();
        switch(menu) {
            case 'edit':
                this.props.addOrEditAttribute(this.props.attr, e);
            break;
            case 'add-to-x':
                this.props.addRemoveAttributeOnAxis(this.props.attr,'x','add', e);
            break;
            case 'add-to-y':
                this.props.addRemoveAttributeOnAxis(this.props.attr,'y','add', e);
            break;
            case 'add-to-y2':
                this.props.addRemoveAttributeOnAxis(this.props.attr,'y2','add', e);
            break;
            case 'orderby':
                this.props.onOrderByAttributeSelected(this.props.attr, e);
            break;
            case 'colorby':
                this.props.onAttributeNameSelected(this.props.attr, e);
            break;
        }
    }
    focus = () => {
        this.refs.trigger.focus()
    }
    render = () => {
        if(!this.props.Dyn.plotView || !this.props.Dyn.plotView.plotShaper) {
            return <></>;
        }
        let attrName = this.props.attr.name;
        let allowCustomOrderBy = this.props.Dyn.plotView.plotShaper.allowCustomOrderBy()
        let wantAddToY2Axis = this.props.attr.rawAttr.stats.isNumeric() && !!this.props.Dyn.plotView.y2Axis;
        let orderByProps = {};
        if(allowCustomOrderBy) {
            orderByProps.onClick= (e) => {
                this._onItemClick(e, 'orderby');
            }
        } else {
            orderByProps.className = 'tde-disabled';
            orderByProps["aria-disabled"] = true;
        }
        return (
            <div className="tde-attributes-td tde-attribute-actions tde-text-left">
                <SubMenu
                    container={this.props.toolsContainer}
                    id={this.subMenuId}
                    data-level="1"
                    buttonId={this.buttonId}
                    menuId={this.menuId}
                    aria-label={this.props.getLoc('Interact with ') + this.props.attr.name}
                    label={<div
                        style={{padding: '8px'}}
                    >
                        <i className="tde-i tde-i-triangle-bottom"></i>
                    </div>}>
                    <MenuItem id={this.menuItemIds.edit} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Edit Attribute {{attributename}}', {"attributename": attrName})}
                        onClick={e => this._onItemClick(e, 'edit')}>
                        <div>{this.props.getLoc('Edit')}</div>
                    </MenuItem>
                    <MenuItem id={this.menuItemIds.addToX} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Add Attribute {{attributename}} to X Axis', {"attributename": attrName})}
                        onClick={e => this._onItemClick(e, 'add-to-x')}>
                        <div>{this.props.getLoc('Add to X Axis')}</div>
                    </MenuItem>
                    <MenuItem id={this.menuItemIds.addToY} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Add Attribute {{attributename}} to Y Axis', {"attributename": attrName})}
                        onClick={e => this._onItemClick(e, 'add-to-y')}>
                        <div>{this.props.getLoc('Add to Y Axis')}</div>
                    </MenuItem>
                    {wantAddToY2Axis && <MenuItem id={this.menuItemIds.addToY2} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Add Attribute {{attributename}} to Y2 Axis', {"attributename": attrName})}
                        onClick={e => this._onItemClick(e, 'add-to-y2')}>
                        <div>{this.props.getLoc('Add to Y2 Axis')}</div>
                    </MenuItem>}
                    <MenuItem id={this.menuItemIds.colorBy} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Color by Attribute {{attributename}}', {"attributename": attrName})}
                        onClick={e => this._onItemClick(e, 'colorby')}>
                        <div>{this.props.getLoc('Color by Attribute')}</div>
                    </MenuItem>
                    <MenuItem id={this.menuItemIds.orderBy} data-level="2" role="menuitem" className="tde-cell" aria-label={this.props.Dyn.loc('Order by Attribute {{attributename}}', {"attributename": attrName})}
                        aria-disabled={orderByProps.disabled ? "true" : "false"}
                        {...orderByProps}>
                        <div>{this.props.getLoc('Order by Attribute')}</div>
                    </MenuItem>
                </SubMenu>
            </div>
        )
    }
}

export default AttrA11yListDropDown;
